import { createFileRoute } from '@tanstack/react-router';
import { CampaignDraftsRouteView } from '@/pages/workspaces/automations/[campaignId]/drafts/routing';

function CampaignDraftsRoute() {
  const { campaignId } = Route.useParams();
  return <CampaignDraftsRouteView campaignId={campaignId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/drafts')(
  {
    component: CampaignDraftsRoute,
  },
);
